<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <truncate-text class="forge-typography--subheading1" *ngIf="isLoaded" [allowHtml]="true" fxFlex="100" [mainText]="ChartSubtitle">
            </truncate-text>
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding" fxLayout="column">
        <div *ngIf="hasGroups" fxFlex="100" fxLayout="row" [formGroup]="formGroup" class="tt-margin--bottom">
            <lgd-select fxFlex="100" controlName="groupBy" label="Department" [options]="groups">
            </lgd-select>
        </div>

        <div>
            <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>

            <ng-container *ngIf="isLoaded">
                <account-detail-card *ngIf="chartHasData" fxFlex [chartHasData]="chartHasData" [shareable]="true" [totals]="ChartData">
                </account-detail-card>

                <div *ngIf="!chartHasData">
                    Not enough data to display breakdown
                </div>
            </ng-container>
        </div>
    </div>
</forge-card>